import { motion } from "framer-motion";

const chapters = [
  ["01", "SOFORTIGES QR-TICKET", "Name und E-Mail genügen. Dein persönlicher QR-Code erscheint sofort und kommt zusätzlich als Boarding Pass per E-Mail."],
  ["02", "ZAHLUNG AM EINGANG", "Keine Überweisung, kein Bankdaten-Stress. Der Ticketpreis wird direkt beim Einlass bezahlt und vom Team bestätigt."],
  ["03", "NUR 50 FÜR €10", "Streng limitiertes Kontingent: nur 50 Tickets für den Pilot. Wenn sie weg sind, öffnet automatisch die Warteliste."],
];

export const Manifesto = () => (
  <section id="manifest" className="px-5 py-28 sm:px-8">
    <div className="mx-auto max-w-7xl">
      <motion.p initial={{ opacity: 0, y: 20 }} whileInView={{ opacity: 1, y: 0 }} viewport={{ once: true }} className="font-mono text-xs uppercase tracking-[0.24em] text-[#E5C378]">
        Manifest
      </motion.p>
      <motion.h2 initial={{ opacity: 0, y: 24 }} whileInView={{ opacity: 1, y: 0 }} viewport={{ once: true }} transition={{ delay: 0.1 }} className="mt-4 max-w-3xl font-syne text-3xl font-bold tracking-tight text-white sm:text-4xl lg:text-5xl">
        Kein Vorverkauf per Überweisung. Nur QR-Ticket, klare Staffelpreise und Zahlung am Eingang.
      </motion.h2>
      <div className="mt-16 grid gap-5 lg:grid-cols-3">
        {chapters.map(([number, title, description], index) => (
          <motion.article key={number} initial={{ opacity: 0, y: 34 }} whileInView={{ opacity: 1, y: 0 }} viewport={{ once: true, margin: "-80px" }} transition={{ duration: 0.65, delay: index * 0.12 }} className="group rounded-[2rem] border border-white/10 bg-[#13131A]/80 p-8 transition-colors duration-300 hover:border-[#E5C378]/35">
            <p className="font-mono text-sm text-[#E5C378]">{number}</p>
            <h3 className="mt-10 font-syne text-2xl font-bold text-white transition-colors duration-300 group-hover:text-[#E5C378]">{title}</h3>
            <p className="mt-5 text-base leading-relaxed text-zinc-400">{description}</p>
          </motion.article>
        ))}
      </div>
    </div>
  </section>
);
